import { useQuery } from '@tanstack/react-query';
import { useSession } from '@/lib/auth-client';
import { ApiService } from '@/_services/api.service';
import { queryKeys } from './queryKeys';
import { DEFAULT_CONVERSATION_PAGE_SIZE } from '@/_constants/defaultConversationPageSize';

/**
 * Query hook to fetch paginated conversations
 * Used in the sidebar to display conversation history
 *
 * Only fetches when user is authenticated
 */
export const useConversationsQuery = (page: number = 1, pageSize: number = DEFAULT_CONVERSATION_PAGE_SIZE) => {
	const { data: session } = useSession();

	return useQuery({
		queryKey: queryKeys.conversations.paginated(page, pageSize),
		queryFn: async () => {
			const { data, error } = await ApiService.GetConversations({ page, pageSize });
			if (error || !data) {
				throw new Error(error?.message || 'Failed to fetch conversations');
			}
			return data;
		},
		// Only fetch when user is authenticated
		enabled: !!session?.user
	});
};
